/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LoyaltyProfileIdQueryVariables = Exact<{ [key: string]: never }>;

export type LoyaltyProfileIdQuery = {
  readonly loyaltyProfile: {
    readonly __typename: 'LoyaltyProfile';
    readonly loyaltyId: string | null;
    readonly customerId: string;
  } | null;
};

export const LoyaltyProfileIdDocument = gql`
  query LoyaltyProfileId {
    loyaltyProfile {
      __typename
      ... on LoyaltyProfile {
        loyaltyId
        customerId
      }
    }
  }
`;

export function useLoyaltyProfileIdQuery(
  options?: Omit<Urql.UseQueryArgs<LoyaltyProfileIdQueryVariables>, 'query'>,
) {
  return Urql.useQuery<LoyaltyProfileIdQuery, LoyaltyProfileIdQueryVariables>({
    query: LoyaltyProfileIdDocument,
    ...options,
  });
}
